module.exports = __webpack_public_path__ + "img/index_bottom.95547fa9.png";